import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HelpersService } from '../../services/tools/helpers.service';
import { PromotoresService } from '../../services/promotores.service';
import { ModalPromotorComponent } from './components/modal-promotor/modal-promotor.component';

@Component({
    selector: 'app-promotores-listado',
    templateUrl: './promotores-listado.component.html'
  })

export class PromotoresListadoComponent implements OnInit {
    @ViewChild('modalPromotor') public modalFechaContrato: ModalPromotorComponent;
    @ViewChild('btnShowDeleteModal') btnShowDeleteModal: ElementRef;

    public promotores: any [] = [];
    public promotorToDelete = null;
    public isLoading: boolean = false;
    //Filters 
    public searchText: string = '';
    //Pagination vars
    public page: number = 1;
    public pageSize: number = 0;
    public pageAll: number = 0;
    public paginationInfo = { from : null, to : null, total : null };

    constructor(
        private helperService : HelpersService,
        private service : PromotoresService
    ){
    }

    public ngOnInit() {
        this.getPromotores();
    }

    public addPromotor(){
        this.modalFechaContrato.showModal();
    }

    public editPromotor(idPromotor: number){
      this.modalFechaContrato.editPromotor(idPromotor);
  }

    public getPromotores(){
        let filters = this.getActiveFilters();
    
        this.isLoading = true;
        this.service.getAll(filters).subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content && jsonResult.content.data){
              const jsonContent = response.json().content;
              this.promotores = jsonContent.data;
              this.page = jsonContent.current_page;
              this.pageSize = jsonContent.per_page;
              this.pageAll = jsonContent.total;
              this.paginationInfo.from = jsonContent.from;
              this.paginationInfo.to = jsonContent.to;
              this.paginationInfo.total = jsonContent.total;
            }
            
            this.isLoading = false;
          }, error =>
          {
            this.isLoading = false;
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    private getActiveFilters(){
        let filters = {
          page : null,
          search : null,
          paginate : true
        };
    
        if(this.page){
          filters.page = this.page;
        }
    
        if(this.searchText){
          filters.search = this.searchText;
        }
    
        return filters;
    }

    public selectPromotorToDelete(event : any, promotor : any){
        event.stopPropagation();
        this.promotorToDelete = promotor;
        this.btnShowDeleteModal.nativeElement.click();
    }

    public deletePromotor(){
        let filters = this.getActiveFilters();
    
        this.service.delete(this.promotorToDelete.id).subscribe(
          (response)=>
          {
            const jsonContent = response.json().content;
            this.getPromotores();
            this.helperService.notification('Promotor eliminado', 'Se ha eliminado exitosamente el promotor', 'success');
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/promotores/listado/promotores-listado.component.ts